import { useContext, useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import { ReportTable } from '../components/reportTable';
import { getDataSource } from '../api/ds';
import { Typography, Button, Dialog, TextField, Divider } from '@mui/material';
import { colors } from '../styles/colors';
import useOn from 'components/socketLib/UseOn';
import { useDataContextDeal } from 'actions/contextDealClient';
import { useNavigate, unstable_usePrompt as usePrompt } from 'react-router-dom';
import { DateMenu } from 'components/RangeDate';
import { get, post } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import usePreventDoubleClick from 'components/AntiDBC';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { MarketClientSelector } from 'store/slices/marketClient';
import { useLocalNotifications } from 'components/Events';
import { AddProducts } from 'components/AddProducts';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { SelectProductTocopy } from 'components/EIComponents/ProductInfo';
import { ShowModal } from "components/Modal";
import { useBlocker } from 'react-router-dom';
import Scrollbars from 'rc-scrollbars';
import Loading from 'components/Load';
import { NumInputDesign, TextInputDesign } from 'components/EIComponents/LittleComponents';
import { sortProducts } from 'utils/globalSorts';
import { hoverStyle } from "styles/main";

// поставки по клиентам 
export function DeliveryClientConsumabels() {
    // Состояние, указывающее, есть ли несохраненные изменения в форме
        const [isFormDirty, setIsFormDirty] = useState(false);
        // Флаг для перехода на другую страницу после успешной операции
        const [shouldNavigate, setShouldNavigate] = useState(false);
        
        const [loadingButton, setLoadingButton] = useState(false);
        // Данные
        /** @type {[Array<any>, Function]} */
        const [data, setData] = useState([]);
         // Количество тюков
        const [countBale, setCountBale] = useState(1);
        // склад фулы и склад маркета
        const [warehouse_tranzit, setwarehouse_tranzit] = useState("");
        const [warehouse_market, setWarehouse_market] = useState("");
        const [pickup_addr, setPickup_addr] = useState("");
        const [pickup_contact, setPickup_contact] = useState("");
        const [pickup_sign, setPickup_sign] = useState("");
        const [pickup_volume, setPickup_volume] = useState("");
        // дата отгрузки
        const [date_shipment, setDate_shipment] = useState(new Date());
        // состояние ошибки, если пользователь напортачил
        const [error, setError] = useState(false);
        // Состояние для открытия модального окна добавления товара
        const [open, setOpen] = useState(false);
        // Навигационный хук из React
        const navigate = useNavigate();
        // получаем дескриптор
        const ds = useMemo(() => getDataSource('dealClientConsum'), []);
        // получаем контекст с выбранными товарами
        /** @type {any} */
        const { dataContext, clearContextData } = useDataContextDeal();
        const { socket } = useContext(SocketContext);
        const { company_id, user_id  } = useSelector(
            loginSelector
          );
        const { showNotification } = useLocalNotifications();
        const preventDoubleClick = usePreventDoubleClick();
        const [openCopy, setOpenCopy] = useState(false);
        const [copyData, setCopyData] = useState(undefined)

        const blocker = useBlocker(
            ({ nextLocation, currentLocation }) =>
                isFormDirty && nextLocation.pathname !== currentLocation.pathname
        );
    
        // обновляем кол-во страниц, когда залились пдф файлы
        useOn('updateCountPages', ($data) => {
            if ($data) {
                const index = data.findIndex((el) => el.size.barcode === $data.size);
                if (index !== -1) {
                    data[index].size.countQr = $data.count;
                    setData(JSON.parse(JSON.stringify(data)));
                }
            }
        });
         // Хук для предупреждения пользователя при попытке уйти со страницы с несохраненными изменениями
        useEffect(() => {
            if (blocker.state === "blocked") {
                ShowModal(
                    'Несохраненные изменения',
                    <div>У вас есть несохраненные изменения. Вы уверены, что хотите покинуть страницу?</div>,
                    async () => {
                        blocker.proceed(); 
                    }
                );
            }
        }, [blocker]);
    
        // при необходимости перехода на другую страницу, если форма не заполнялась или сохранена
        useEffect(() => {
            if (shouldNavigate && !isFormDirty) {
                navigate('..', { relative: 'path', replace: true });
            }
        }, [shouldNavigate, isFormDirty, navigate]);
    
        // Функция создания новой поставки
        const create = async () => {
            setLoadingButton(true)
            if (data.length === 0) {
                showNotification({
                    id: 'Null Products', 
                    type: 'error', 
                    message: 'Ни один товар не добавлен' 
                });
                return
            }
            const $data = [];
            for (const el of data) {
                // Собираем объект товара
                const item = { nmID: el.nmID, countProduct: el.countProduct, ...el.data, size: el.size, rck: el.rck};
                
                $data.push(item);
            }

    
            const cli = await get('Clients/get', {cid:user_id});
            console.log("cli", cli)
            $data.map((el) => {delete el.size.countQr})
            let sku = $data.length;
            let units = 0
            $data.map((el) => {
                units += parseInt(el.countProduct);
                el.photo = el.photopath
            })
            let nd = await post('Deal/create', 
                {
                    products: $data, 
                    count_bale: countBale, 
                    warehouse_tranzit: warehouse_tranzit, 
                    warehouse_market: warehouse_market, 
                    date_shipment, 
                    id_company: company_id, 
                    id_client: user_id, 
                    id_manager: Number(cli.message.manager_id), 
                    market: 'consum', 
                    number_order: "", 
                    status: 1, 
                    type: "pik_goods",//Важно, так он попадает в раздел отгрузка
                    data:{
                            sku,
                            units,
                            end_date:date_shipment,
                            pickup: {
                                contact:pickup_contact,
                                addr:pickup_addr,
                                sign:pickup_sign,
                                volume:pickup_volume
                            }
                        }
                })
            if (nd?.id) {
                await post("Logs/create", {
                    deal_id:nd.id,
                    user_type:"cli",
                    user_id,
                    type: "create_deal",
                    data: {
                        sku,
                        units,
                    }
                })
                socket.emit('add_new_deal', {company_id, type: "pik_goods", id:nd.id});
                setShouldNavigate(true);
                setIsFormDirty(false);
            }
            else {
                showNotification({
                    id: 'createDealErr', 
                    type: 'error', 
                    message: 'Ошибка при создании сделки, сообщите администратору' 
                });
            }
            setLoadingButton(false)
        }
    
        // // Обработка изменений технического задания
        // const changeTechText = ($data) => {
        //     if (!$data.copy) {
        //         const found = data.findIndex((el) => String(el.id) === String($data.row.id));
        //         console.log("found", found)
        //         if (found !== -1) {
        //             if ($data.row?.expId) {
        //                 const foundExp = data[found].expanded.findIndex((el) => String(el.id) === String($data.row.expId))
        //                 if (foundExp !== -1) {
        //                     data[found].expanded[foundExp].size.techTask = {text: $data.text, services: $data.services};
        //                     setData(JSON.parse(JSON.stringify(data)));
        //                 }
        //             } else {
        //                 data[found].size.techTask = {text: $data.text, services: $data.services};
        //                 setData(JSON.parse(JSON.stringify(data)));
        //             }
        //         }
        //     }
        //     else {
        //         setCopyData(JSON.parse(JSON.stringify($data)))
        //         setOpenCopy(true)
        //     }
        // }
    
        // const copyTechTask = async (list) => {
        //     console.log(list)
        //     delete copyData.copy
        //     console.log("copyData", copyData)
        //     for (let el of list) {
        //     changeTechText({...copyData, row: {id: el}})
        //     }
        //     setCopyData(undefined)
        // }

        const [allSKU, setAllSKU] = useState(0)
        const [allProduct, setAllProduct] = useState(0)


        // обновляем кол-во страниц, когда залились пдф файлы
        useOn('updateCountPages', ($data) => {
            console.log('DATA DELIVERY', $data)
            if ($data) {
                const index = data.findIndex((el) => el.size.barcode === $data.size)
                console.log('INDEX DELIVERY', index)
                if (index !== -1) {
                    // data[index].size.countQr = $data.count;
                    data[index].qrcode.count = $data.count;
                    setData(JSON.parse(JSON.stringify(data)));
                }
            }
        });

        const changeRow = async ($data) => {
            console.log("$data", $data)
            if ($data.fk && $data.fk==='count') {
                let tmp = JSON.parse(JSON.stringify(data))
                const found = tmp.findIndex((el) => String(el.id) === String($data.row.id))
                if (found !== -1) {
                    tmp[found].countProduct = $data.count
                }
                setData(tmp)
                return
            }
        }
    
        const counttest = () =>{
            console.log("test", data)
            let allsku = 0
            let allproduct = 0
            if (data && data.length > 0){
                allsku = data.length
                for(let i = 0 ; i < data.length ; i++){
                    allproduct += data[i].countProduct;
                }
    
                console.log('COUNT SKU', allsku);
                console.log('COUNT PRODUCT', allproduct);
            }
            
            setAllSKU(allsku)
            setAllProduct(allproduct)
        }
    
        useEffect(() => {
        counttest()
            }, [data]); 
    
        // Обработка полученного из контекста
        useEffect(() => {
            if (dataContext) {
                setIsFormDirty(true);
                // предобработка данных под формат, чтобы отображать в таблице и редактировать
                let tmp = JSON.parse(JSON.stringify(data))
                for (const el of dataContext.deal) {
                    let idx = tmp.findIndex((fel) => fel.nmID === el.nmID && fel.size.barcode === el.size.barcode)
                    if (idx === -1) {
                        el.qrcode = { id: el.id, nmID: el.nmID, title: el.data.title, size: el.size, market: el.market, company: company_id, count: el.size.countQr, vendorCode: el.data.vendorCode};
                        tmp.push(el)
                    }               
                    else {
                        tmp[idx].countProduct += el.countProduct
                    } 
                }
                // Добавляем данные к текущему состоянию
                setData(tmp);
                counttest()
                clearContextData();
            } else {
                // Если данных нет — возвращаемся на предыдущую страницу
                if (data.length === 0) {
                    navigate('..', { relative: 'path', replace: true });
                }
            }
        }, [dataContext]);
    
        const del = async (id) => {
            let tmp = JSON.parse(JSON.stringify(data))
            let idx = tmp.findIndex((fel) => fel.id === id)
            if (idx > -1) {tmp.splice(idx, 1)}
            setData(tmp)
        }

        const handleClickDelConsum = (item) => {
            ShowModal('Удалить расходник', 
            <div>Вы уверены, что хотите удалить расходник?</div>, 
            async () => {
                try {
                del(item)
                }
                catch (err) {}
                finally {}
                
            });
        }
    
        console.log("data", data)

    return (
        <Box height="100%" display="flex" flexDirection="column" >
            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '620px', width: '1200px', padding: '12px' }}>
                    <AddProducts navigateDeal={false} cancel={setOpen}></AddProducts>
                </div>
            </Dialog>
            <Box 
                sx={{
                    width: "98%",
                    height: '15%',
                    margin: "1% 1% 0% 1%",
                    display:'flex', 
                    flexDirection:'row', 
                    gap:2, 
                    padding: "1% 1% 0% 1%",
                    backgroundColor:'white',
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px"
                }}
            >
                <div style={{display: "flex", flexDirection:"column", gap: "2px"}}>
                    <TextInputDesign title={"Адрес для забора:"} val={pickup_addr} onChange={(v) => setPickup_addr(v)}/>
                    <TextInputDesign title={"Контакт:"} val={pickup_contact} onChange={(v) => setPickup_contact(v)}/>
                    <TextInputDesign title={"Подписание груза:"} val={pickup_sign} onChange={(v) => setPickup_sign(v)}/>
                </div>
                <div style={{ display:"flex", alignItems:"center"}}>
                    <Divider orientation="vertical" sx={{ borderRightWidth: "3px", height:"95%" }} />
                </div>
                <div style={{display: "flex", flexDirection:"column", gap: "2px"}}>
                    <NumInputDesign title={"Кол-во мест"} val={countBale} onChange={(v) => setCountBale(v)}/>
                    <NumInputDesign title={"Объём в м³"} val={pickup_volume} onChange={(v) => setPickup_volume(v)}/>
                    <span>Количество товара: {allProduct}</span>
                    <span>SKU: {allSKU}</span>
                </div>
            </Box>
            <div style={{
                width: '98%', 
                height: '77%',
                margin: "0% 1% 1% 1%",
                backgroundColor:'white',
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px"
            }}>
                <Scrollbars
                    style={{ width: '100%', height: '100%', borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}
                >
                    <ReportTable 
                        ds={ds} 
                        data={sortProducts(data)} 
                        onFormatterChange={changeRow}
                        aditionalAction={
                            [
                                {
                                    action: (item) => {handleClickDelConsum(item.id)},
                                    ui: () => {return (
                                        <DeleteForeverIcon
                                            sx={{
                                                transition: 'all 0.3s ease',
                                                '&:hover': hoverStyle
                                            }}
                                        />
                                    )}
                                }
                            ]
                        }
                    />
                </Scrollbars>
            </div>
            <Box height="5%" display="flex" justifyContent="right" alignItems="center" px={2} sx={{marginBottom: "1%"}}>
                <Button variant="contained" onClick={() => { setOpen(true) }}
                    disabled={loadingButton}
                    sx={{ textTransform: 'none', marginRight: '10px', backgroundColor: colors.elements, fontWeight: 'bold' }} >
                    Добавить товар
                </Button>
                <Button variant="contained"
                    onClick={preventDoubleClick(create, 1000)}
                    disabled={loadingButton}
                    sx={{ textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }} >
                    Создать поставку
                </Button>
                {loadingButton && <Loading/>}
            </Box>
        </Box>

    );
}

